/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */
// import _ from 'lodash'

import Transformer from './Transformer'

export default class AccountTransformer extends Transformer {
  /**
   * Method used to transform a fetched account.
   *
   * @param account The fetched account.
   *
   * @returns {Object} The transformed account.
   */
  static fetch (account) {
    return {
      id: account.sub,
      email: account.name,
      firstName: account.first_name || account.nickname,
      lastName: account.last_name || account.name,
      avatar: account.picture,
      merchants: account.merchants,
      merchantLocations: account.merchant_locations
    }
  }

  /**
   * Method used to transform a send account.
   *
   * @param account The account to be send.
   *
   * @returns {Object} The transformed account.
   */
  static send (account) {
    return {
      email: account.email,
      first_name: account.firstName,
      last_name: account.lastName,
      avatar: account.avatar
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/AccountTransformer.js